module.exports = __webpack_public_path__ + "media/images/icons/plus-92e58d0be6efbad8089a9f0c955d633e.svg";